module.exports = __webpack_public_path__ + "img/chat-tool.51f9a3ca.svg";